import {defineNuxtPlugin} from '#app';
import {useWidgetStore} from '~/store/widget';
import {useUserStore} from '~/store/user';
import {type NavigationGuard, useRoute} from 'vue-router';
import type {Pinia} from 'pinia';

export type MiddlewareKey = 'has-widget' | 'auth'; // Add your keys here
export type Middleware = MiddlewareKey | NavigationGuard | (MiddlewareKey | NavigationGuard)[];

export default defineNuxtPlugin(async (nuxtApp) => {
  if (!nuxtApp.$pinia) {
    console.error("Pinia not found");
    return;
  }

  const widgetStore = useWidgetStore(nuxtApp.$pinia as Pinia);
  const userStore = useUserStore(nuxtApp.$pinia as Pinia);

  const route = useRoute();
  const middleware = route.meta.middleware as Middleware;

  // Normalize middleware into an array
  const middlewareArray: (MiddlewareKey | NavigationGuard)[] = Array.isArray(middleware)
    ? middleware
    : middleware
      ? [middleware]
      : [];

  if (userStore.isAuthenticated && widgetStore.widgets.length === 0) {
    if (middlewareArray.includes('has-widget')) {
      await widgetStore.getWidgets();
    }
  }
});